// extracted by mini-css-extract-plugin
module.exports = {"list-container":"SecondaryFields_list-container__EKU4o","field-text":"SecondaryFields_field-text__2typQ","item-container":"SecondaryFields_item-container__2YlPg"};